/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `Queued` - Queued * `Started` - Started * `Finished` - Finished * `Failed` - Failed
 * @export
 * @enum {string}
 */

export const RqStatusStateEnum = {
    Queued: 'Queued',
    Started: 'Started',
    Finished: 'Finished',
    Failed: 'Failed'
} as const;

export type RqStatusStateEnum = typeof RqStatusStateEnum[keyof typeof RqStatusStateEnum];



